import { useState, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils';
import { LoadingMode } from '../Components/LoadingMode';

function Faq() {
  const [isLoading, setIsLoading] = useState(false);
  const [faqs, setFaqs] = useState([]);
  const [toggleAnswer, setToggleAnswer] = useState(null);

  const { token: userToken } = getToken();

  useEffect(() => {
    const faq = async () => {
      setIsLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/faqs`;

      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        setFaqs(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    faq();
  }, [userToken]);

  const handleshowandHideAnswer = (id) => {
    if (toggleAnswer === id) {
      setToggleAnswer(null);
    } else {
      setToggleAnswer(id);
    }
  };
  return isLoading ? (
    <LoadingMode />
  ) : (
    <article>
      <div className='bg-f-bk flex flex-row justify-center items-center text-2xl text-pbk py-12 '>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='28'
          height='28'
          viewBox='0 0 26 26'
          className='text-p-bk/70 mr-3'
        >
          <path
            fill='currentColor'
            d='M13 0c-1.7 0-3 1.3-3 3v6c0 1.7 1.3 3 3 3h6l4 4v-4c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3H13zm4.188 3h1.718l1.688 6h-1.5l-.407-1.5h-1.5L16.813 9H15.5l1.688-6zM18 4c-.1.4-.212.888-.313 1.188l-.28 1.312h1.187l-.282-1.313C18.113 4.888 18 4.4 18 4zM3 10c-1.7 0-3 1.3-3 3v6c0 1.7 1.3 3 3 3v4l4-4h6c1.7 0 3-1.3 3-3v-6h-3c-1.9 0-3.406-1.3-3.906-3H3zm4.594 2.906c1.7 0 2.5 1.4 2.5 3c0 1.4-.481 2.288-1.281 2.688c.4.2.874.306 1.374.406l-.374 1c-.7-.2-1.426-.512-2.126-.813c-.1-.1-.275-.093-.375-.093C6.112 18.994 5 18 5 16c0-1.7.994-3.094 2.594-3.094zm0 1.094c-.8 0-1.188.9-1.188 2c0 1.2.388 2 1.188 2c.8 0 1.218-.9 1.218-2s-.418-2-1.218-2z'
          />
        </svg>
        Frequently ask questions
      </div>
      <div className='grid  gap-4 px-12 my-12 mb-1'>
        {faqs.map((faq) => (
          <div className='col-span-1' key={faq.id}>
            <p
              className='px-4 py-2 shadow bg-p-wh w-full mb-1 flex flex-row justify-between  cursor-pointer text-p-bk'
              onClick={() => handleshowandHideAnswer(faq?.id)}
            >
              {faq?.question}
              <span className='font-semibold text-xl'>+</span>
            </p>
            {toggleAnswer === faq?.id && (
              <p className='px-4 py-2 bg-p-wh w-full text-s-bk'>
                {faq?.answer}
              </p>
            )}
          </div>
        ))}
      </div>
    </article>
  );
}

export default Faq;
